"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressToJSON = exports.AddressFromJSONTyped = exports.AddressFromJSON = void 0;
const runtime_1 = require("../runtime");
function AddressFromJSON(json) {
    return AddressFromJSONTyped(json, false);
}
exports.AddressFromJSON = AddressFromJSON;
function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'country': json['country'],
        'lineOne': json['lineOne'],
        'lineTwo': !runtime_1.exists(json, 'lineTwo') ? undefined : json['lineTwo'],
        'locality': json['locality'],
        'subdivision': json['subdivision'],
        'postalCode': !runtime_1.exists(json, 'postalCode') ? undefined : json['postalCode'],
    };
}
exports.AddressFromJSONTyped = AddressFromJSONTyped;
function AddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country': value.country,
        'lineOne': value.lineOne,
        'lineTwo': value.lineTwo,
        'locality': value.locality,
        'subdivision': value.subdivision,
        'postalCode': value.postalCode,
    };
}
exports.AddressToJSON = AddressToJSON;
//# sourceMappingURL=Address.js.map